import mixpanel from 'mixpanel-browser';

export default function mixpanelEvent(message, properties) {
  if (process.env.NODE_ENV === 'development') return;

  mixpanel.init('ab5a1561fa50c580dec118d43f54136e');
  mixpanel.track(message, properties);
}
